// extracted by mini-css-extract-plugin
export default {"preloaderWrapper":"Preloader_preloaderWrapper__ezazX","ldsRipple":"Preloader_ldsRipple__3dKcK","lds-ripple":"Preloader_lds-ripple__jX0Ex"};